const deliveryNotesTypes = {
  DELIVERY_NOTES_TABLE_STATE_SET: 'DELIVERY_NOTES/TABLE_STATE_SET',
  DELIVERY_NOTES_TABLE_STATE_RESET: 'DELIVERY_NOTES/TABLE_STATE_RESET',
};
export default deliveryNotesTypes;
